import apiSlice from "./ApiSlice";
import { v4 as uuid } from "uuid";

const deviceId = localStorage.getItem("deviceId") || uuid();

export const UserServiceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //Get All User
    getAllUserData: builder.query({
      providesTags: ["user"],
      query: (body) => {
        return {
          url: "/user",
          method: "POST",
          body,
        };
      },
    }),

    //Get User
    getAllUser: builder.query({
      providesTags: ["user"],
      query: () => {
        return {
          url: "/user",
          method: "POST",
        };
      },
    }),

    // add User
    addUser: builder.mutation({
      invalidatesTags: ["user"],
      query: (body) => ({
        url: `/user/signup`,
        method: "POST",
        headers: {
          "device-id": deviceId,
        },
        body,
      }),
    }),

    // update User
    updateUser: builder.mutation({
      invalidatesTags: ["user"],
      query: ({ body, id }) => {
        return {
          url: `/user/profile/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    //Get Single User
    getSingleUser: builder.query({
      providesTags: ["user"],
      query: ({ id }: { id: string }) => {
        return {
          url: `/user/${id}`,
          method: "GET",
        };
      },
    }),

    getAdminData: builder.query({
      providesTags: ["user"],
      query: ({ id }: { id: string }) => {
        return {
          url: `/user/${id}`,
          method: "GET",
        };
      },
    }),

    getUserData: builder.query({
      providesTags: ["user"],
      query: ({ id }: { id: string }) => {
        return {
          url: `/user/my-profile`,
          method: "GET",
        };
      },
    }),

    // delete
    deleteUser: builder.mutation({
      invalidatesTags: ["user"],
      query: (id) => {
        return {
          url: `/user/${id}`,
          method: "DELETE",
        };
      },
    }),

    // change status
    changeStatusUserById: builder.mutation({
      invalidatesTags: ["user"],
      query: ({ body, id }) => {
        return {
          url: `/user/status-change/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useAddUserMutation,
  useUpdateUserMutation,
  useGetSingleUserQuery,
  useGetAllUserQuery,
  useDeleteUserMutation,
  useChangeStatusUserByIdMutation,
  useGetAllUserDataQuery,
  useGetUserDataQuery,
  useGetAdminDataQuery,
} = UserServiceApi;
